<template>
<!-- 视频点播详情 -->
    <div class="video_detail_warp">
        <BaseDetail ref="baseDetail">
            <template slot="top" scope="{info}">
                <div  class="video_box">
                    <!-- 视频 -->
                    <div class="video_l_content" v-if="true">
                        <video ref="audio" controls="controls" width="100%" height="100%" :src="info.videourl" autoplay></video>
                    </div>
                    <div class="video_l_footer">
                        <div class="cont_top_title">{{info.title}}</div>
                        <div class="behavior_box">
                            <div style="color:#2f69ed;">浏览 0 </div>
                            <div class="behavior_list">
                               
                                <div class="behavior_item" @click="praise">
                                    <svg-icon icon-class="thumb" :class="operCount.ydz? 'active_icon': ''" class="item_icon" />
                                    
                                    {{operCount.dzs}}
                                </div>
                                <div class="behavior_item" @click="collect">
                                    <i class="el-icon-star-off item_icon" :class="operCount.ysc? 'active_icon': ''"  />
                                    {{operCount.scs}}
                                </div>
                                <!-- <div class="behavior_item">
                                    <i class="el-icon-share item_icon"/> 分享
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template slot="cont" scope="{info}">
                <div class="cont_warp" v-html="info.info">
                </div>
            </template>
        </BaseDetail>
    </div>
</template>

<script>
import BaseDetail from '@c/BaseDetail'
import { post } from '@u/request'
import { mapGetters } from 'vuex'

export default {
    name: 'videoDetail',
    components: {
        BaseDetail
    },
    data() {
        return {
            operCount: {}
        }
    },
    computed: {
        ...mapGetters([
            'readerId',
        ]),
        contentId() {
            return this.$route.params.id
        }
    },
	watch: {
	    'readerId'(value){
		    this.operinfo()
	    }
	},
    methods: {
        async praise() {
            if (!this.readerId) {
                this.$store.commit('SET_VISIBLE_LOGIN',true);
                return
            }
            if (this.operCount.ydz) {
                this.$message.success('已经点赞啦！');
                return;
            }
            const params = {
                readerId: this.readerId,
                contentId: this.contentId
            }
            const { data } = await post('resource/praise/add', params)
            this.$message.success('点赞成功！')
            this.operinfo()
        },
        async collect() {
            if (!this.readerId) {
                this.$store.commit('SET_VISIBLE_LOGIN',true);
                return
            }
            if (this.operCount.ysc) {
                this.$message.success('已经收藏啦！');
                return;
            }
            const params = {
                readerId: this.readerId,
                contentId: this.contentId
            }
            const { data } = await post('resource/collect/add', params)
            this.$message.success('收藏成功！')
            this.operinfo()
        },
        async operinfo() {
            const params = {
                readerId: this.readerId,
                contentId: this.contentId
            }
            const { data } = await post('resource/showapi/operinfo', params);
            this.operCount = data;
        }
    },
    mounted() {
        this.$refs.baseDetail.videoLoad('showcontent')
        this.$refs.baseDetail.loadCommentList('contentId')
        this.operinfo()
    }
}
</script>

<style scoped lang="scss">
.video_detail_warp {
    background: #f8f8f8;
    padding-top: 20px;
    min-height: calc(100vh - 315px);
    .video_box {
        width: 100%;
        background: #000;
        .video_l_content {
            height: 675px;
            position: relative;
        }
       
        .video_l_footer {
            padding: 27px 30px 30px;
            line-height: 1;
            font-size: 20px;
        }
        .cont_top_title {
            font-size: 24px;
            font-weight: 800;
            color: #fff;
        }
        .behavior_box {
            display: flex;
            align-items: center;
            font-size: 20px;
            color: #777;
            padding: 27px 0 20px;
        }
        .behavior_list {
            margin-left: auto;
            display: flex;
            .behavior_item {
                width: 118px;
                height: 47px;
                line-height: 47px;
                text-align: center;
                border-radius: 5px;
                background: #f5f5f5;
                cursor: pointer;
                margin-left: 18px;
            }
        }
        .item_icon {
            font-size: 23px;
        }
        
    }
    .cont_warp {
        width: 100%;
        background: #fff;
        box-shadow: 0 10px 18px 0 rgba(0,0,0,.05);
        border-radius: 5px;
        padding: 45px 30px;
        word-wrap:break-word;
        overflow: hidden;
    }
    .active_icon {
        color: #a80000;
    }
}
</style>